module.exports = __webpack_public_path__ + "static/irfana-f9043f96e8f015adb13dc21a4461f655.jpeg";